const configuredValue = process.env.VUE_APP_ALLOW_ACCOUNT_CREATION;

export const accountCreationAllowed = configuredValue === undefined || configuredValue.trim().toLowerCase() === "true";
